import React, { useState } from "react";
import { BsWhatsapp } from "react-icons/bs";
import { BsTelegram } from "react-icons/bs";
import ContactUsFormPopup from "../ContactUsFormPopup/ContactUsFormPopup";

export default function ChatBotNew() {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <div className="fixed bottom-0 w-fit mb-4 justify-center  left-1/2 transform -translate-x-1/2">
        <div className="bg-gray-900 w-[210px] md:w-[300px] h-[55px] flex flex-row items-center justify-evenly">
          <BsTelegram
            className="text-white size-5  md:size-8 cursor-pointer hover:scale-125 transition-all duration-300 hover:text-bhagwa"
            onClick={() => {
              window.open("https://t.me/XperienceRealty_bot", "_blank");
            }}
          />
          <BsWhatsapp
            className="text-white size-5 md:size-8 cursor-pointer hover:scale-125 transition-all duration-300 hover:text-bhagwa"
            onClick={() => {
              // Put some custom message to the user
              window.open(
                "https://wa.me/+971565467991?text=Hi, I've come across the Xperience Realty website and would like further information about Dubai Real Estate from you.",
                "_blank"
              );
            }}
          />
          <span
            className="font-[lato] text-sm md:text-base uppercase text-white cursor-pointer hover:scale-105 transition-all duration-300 hover:text-bhagwa"
            onClick={() => setIsOpen(true)}
          >
            Contact Us
          </span>
        </div>
      </div>
      {isOpen && <ContactUsFormPopup setIsOpen={setIsOpen} />}
    </>
  );
}
